import { render, staticRenderFns } from "./HomeSocial.vue?vue&type=template&id=53c80dbe&"
import script from "./HomeSocial.vue?vue&type=script&lang=js&"
export * from "./HomeSocial.vue?vue&type=script&lang=js&"
import style0 from "./HomeSocial.vue?vue&type=style&index=0&id=53c80dbe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports